export default __webpack_public_path__ + "static/media/youtube.0afa7a76.svg";